import { render, staticRenderFns } from "./resourceImage2.vue?vue&type=template&id=0f2d66f1&scoped=true"
import script from "./resourceImage2.vue?vue&type=script&lang=js"
export * from "./resourceImage2.vue?vue&type=script&lang=js"
import style0 from "./resourceImage2.vue?vue&type=style&index=0&id=0f2d66f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2d66f1",
  null
  
)

export default component.exports